<div class="col p-0 template3 border-outline">
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/payments/payment-status.component.html